// extracted by mini-css-extract-plugin
module.exports = {"root":"OTPInput_root__9nbLY","input":"OTPInput_input__hZmiA","input6":"OTPInput_input6__GcRT_","inputDark":"OTPInput_inputDark__kxx8d"};